var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"dashboard-analytics"}},[_c('analytics-plan-users'),_c('b-row',[_c('b-col',{attrs:{"lg":"6"}},[_c('analytics-count')],1),_c('b-col',{attrs:{"lg":"6"}},[_c('analytics-count-yearly')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }